export default {
    main: 'https://lapi.senior-rm.com'
}
